import Vue from 'vue';
import Component from 'vue-class-component';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);
import Router, { RouteConfig } from 'vue-router';

// SPE Begin  clean home component
// const Home = () => import('@/core/home/home.vue');
const HomeExtended = () => import('@/core/home-extended/home-extended.vue');
const Error = () => import('@/core/error/error.vue');
// SPE End clean home component

// SPE Begin
import acl247 from '@/router/acl-247';
import sawmill from '@/router/sawmill';
import stock from '@/router/stock';
import manufacturing from '@/router/manufacturing';
import maintenance from '@/router/cmms-maintenance';
import label from '@/router/label';
import eventSignup from '@/router/event-signup';
import materialRequestDelivery from '@/router/material-request-delivery';
// SPE End

import admin from '@/router/admin';
import entities from '@/router/entities';
import pages from '@/router/pages';

Vue.use(Router);

// prettier-ignore
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomeExtended',
      component: HomeExtended
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    // SPE Begin
    ...acl247,
    ...sawmill,
    ...stock,
    ...manufacturing,
    ...maintenance,
    ...label,
    ...eventSignup,
    ...materialRequestDelivery,
    // SPE End
    ...admin,
    entities,
    ...pages
  ]
});

export default router;
